<template>
  <!-- display card if  apprenticeships exist-->
  <v-card class="pb-8" flat>    
    <v-card class="v-card__container" flat v-if="showList"
      ><MessageBox>
        <h5>LÄRLINGAR VISAS INTE I PERSONALLISTAN</h5>
        <p>
          Denna sida visar enbart personal med andra roller än lärling. Klicka på fliken
          "lärlingar" för att enbart visa företagets lärlingar.
        </p>
      </MessageBox>

      <v-data-table
        :headers="headers"
        :items="employments"
        sort-by="firstName"
        item-key="id"
        class="mt-6"
      >
        <!-- display full name of the apprentice -->
        <template slot="item.firstName" slot-scope="props">
          <div>
            <router-link :to="'/people/' + props.item.employedId"
              >{{ props.item.firstName }} {{ props.item.lastName }}</router-link
            >
          </div>
        </template>

        <!-- display full start date  -->
        <template slot="item.personalNumber" slot-scope="props">
          <div>{{ props.item.personalNumber }}</div>
        </template>

        <!-- display full start date  -->
        <template slot="item.fromDate" slot-scope="props">
          <div>{{ props.item.fromDate | date }}</div>
        </template>

        <!-- display disconnected apprenticeship -->
        <template slot="item.manuallyEndedDate" slot-scope="props">
          <div class="d-flex justify-center" style="width: 100px">
            <v-checkbox disabled v-model="props.item.manuallyEndedDate"></v-checkbox>
          </div>
        </template>

        <!-- display roleDescription names in  -->
        <template slot="item.role" slot-scope="props">
          <div v-if="selectedCompany && selectedCompany.hasDepartments">
            {{ props.item.isAdministrator
            }}{{ props.item.isAdministrator && rolebyComma(props.item.role) ? "," : "" }}
            {{ rolebyComma(props.item.role) }}
          </div>
          <div v-else>{{ props.item.role }}</div>
        </template>

        <!-- display roleDescription names in  -->
        <template slot="item.roleDescription" slot-scope="props">
          <div>{{ props.item.roleDescription }}</div>
        </template>

        <!-- display full start date  -->
        <template slot="item.mobilephone" slot-scope="props">
          <div>{{ props.item.mobilephone }}</div>
        </template>

        <template slot="item.workplace" slot-scope="props">
          <div>{{ props.item.workplace }}</div>
        </template>

        <template slot="item.icons" slot-scope="props">
          <div class="d-flex justify-space-around">
            <!-- <v-icon v-if="props.item.hasTradeCert">$sl-cert </v-icon> -->
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon class="ml-3" v-if="props.item.hasTradeCert">$sl-cert</v-icon>
                </span>
              </template>
              <span
                v-if="
                  Boolean(
                    props.item.tradeCertificates && props.item.tradeCertificates.length
                  )
                "
              >
                {{
                  props.item.tradeCertificates.map((c) => c.profession.name).join(", ")
                }}
              </span>
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <!-- <v-icon class="ml-2" v-if="props.item.hasTradeCert">$sl-cert</v-icon> -->
                  <v-icon v-if="props.item.hasExemtion" class="ml-1">
                    $sl-user-check</v-icon
                  >
                </span>
              </template>
              <span
                v-if="
                  Boolean(
                    props.item.instructorExemptions &&
                      props.item.instructorExemptions.length
                  )
                "
              >
                {{
                  props.item.instructorExemptions.map((c) => c.profession.name).join(", ")
                }}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template slot="item.action" slot-scope="props">
          <div class="d-flex justify-center">
            <v-icon class="clickable" @click="showEmployeeInfo(props.item)"
              >$sl-view-on</v-icon
            >
            <v-icon data-cy="open-edit-employee" class="ml-2 clickable" @click="editItem(props.item)" :disabled="!canUpdate">
              $sl-edit</v-icon
            >
          </div>
        </template>
      </v-data-table>

      <p class="overline small">Förklaring</p>
      <div class="d-flex caption mt-n2">
        <v-icon class="mr-2">$sl-cert</v-icon>
        <span class="mt-1">Personen har ett eller flera yrkesbevis</span>
      </div>
      <div class="d-flex mt-2 caption">
        <v-icon class="mr-2">$sl-user-check</v-icon>
        <span class="mt-1">Personen har handledardispens</span>
      </div>
      <v-btn
       data-cy="create-employee"
        absolute
        bottom
        right
        fab
        :disabled="!canUpdate"
        @click="
          showCreateNewEmployee = true;
          showEdit = false;
          showList = true;
          showEmployee = false;
        "
      >
        <v-icon class="ml-1">$sl-add</v-icon>
      </v-btn>
    </v-card>

    <!-- The Dialog -->
    <v-dialog v-model="showCreateNewEmployee" max-width="600px">
      <CompanyCreateEmployee
        @close="
          showEdit = false;
          showList = true;
          showEmployee = false;
          showCreateNewEmployee = false;
          getEmployments();
        "
      />
    </v-dialog>

    <div v-if="showEdit">
      <EmploymentInformation
        @show-list="
          showEdit = false;
          showList = true;
          showEmployee = false;
          showCreateNewEmployee = false;
          getEmployments();
        "
        :employmentId="employmentId"
        @backToList="backToList"
      />
    </div>

    <div v-if="showEmployee">
      <EmploymentShow
        @show-edit="
          showEdit = true;
          showList = false;
          showEmployee = false;
          showCreateNewEmployee = false;
          getEmployments();
        "
        :employee="employee"
        @backToList="backToList"
      />
    </div>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import EmploymentInformation from "@/components/company/employments/EmploymentInformation";
import CompanyCreateEmployee from "@/components/company/employments/CreateEmployment";
import EmploymentShow from "@/components/company/employments/EmploymentShow";
import { mapGetters, mapActions } from "vuex";
import find from "lodash/find";
import MessageBox from "@/components/common/MessageBox.vue";
import { CompanyRoles, CanIDo } from "@/components/mixins";

// @group Company
// Styled CompanyEmployments component
export default {
  name: "CompanyEmployments",
  props: {
    reRender: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showList: true,
      showEdit: false,
      showCreateNewEmployee: false,
      showEmployee: false,
      employments: [],
      employmentId: 0,
      employee: {},
    };
  },

  mixins: [CompanyRoles, CanIDo],

  components: {
    EmploymentInformation,
    CompanyCreateEmployee,
    EmploymentShow,
    MessageBox,
  },
  watch: {
    reRender(newValue, oldValue) {
      this.getEmployments();
    },
  },
  /**
   * @vuese
   * Used call apprenticeships  func
   *  @arg  call the functions with no arguments
   */
  created() {
    this.getEmployments();
  },

  computed: {
    ...mapGetters("app", ["isLoading"]),
    ...mapGetters("company", ["selectedCompany"]),

    //- selApprenticenships headers table
    headers() {
      return [
        { text: "Namn", value: "firstName", width: "160" },
        { text: "Personnummer", value: "personalNumber", width: "160" },
        { text: "Bortkopplad", value: "manuallyEndedDate", width: "150" },
        { text: "Roller (Mina sidor)", value: "role", width: "520" },
        { text: "Rollbeskrivning", value: "roledescription", width: "240" },
        { text: "Mobiltelefon", value: "mobilephone", width: "160" },
        { text: "info", value: "icons", align: "center", sortable: false, width: "70" },
        {
          text: "Visa/ändra",
          value: "action",
          align: "center",
          sortable: false,
          width: "120",
        },
      ];
    },
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('employment', 'create');
    },
  },

  methods: {
    ...mapActions("app", ["set_loading"]),
    ...mapActions("company", ["setSelectedCompany", "updateSelectedCompany"]),
    /**
     * @vuese
     * Use to push route to create a new company
     */
    editItem(item) {
      this.employmentId = item.id;
      this.showList = false;
      this.showEmployee = false;
      this.showEdit = true;
      this.showCreateNewEmployee = false;
    },
    showEmployeeInfo(item) {
      this.employee = item;
      this.employmentId = item.id;
      this.showList = false;
      this.showEmployee = true;
      this.showEdit = false;
      this.showCreateNewEmployee = false;
    },

    backToList() {
      this.employmentId = 0;
      this.showList = true;
      this.showEmployee = false;
      this.showEdit = false;
      this.showCreateNewEmployee = false;
    },
    getTradeCertText(item) {
      let ret = "";
      ret = item.employed.tradeCertificates.map((tc) => tc.profession.name).join(",");
      return ret;
    },
    hasTradeCert(item) {
      if (item.employed && item.employed.tradeCertificates) {
        const findApproved = item.employed.tradeCertificates.find(
          (x) => x.approvedById > 0
        );
        if (findApproved) {
          return true;
        }
      }
      return false;
    },
    hasExemtion(item) {
      if (item.employed && item.employed.instructorExemptions) {
        const findApproved = item.employed.instructorExemptions.find(
          (x) => x.approvedById > 0
        );
        if (findApproved) {
          return true;
        }
      }
      return false;
    },
    rolebyComma(departments) {
      if (
        this.selectedCompany &&
        !(this.selectedCompany.hasDepartments &&
        departments &&
        departments.length > 0)
      )
        return;
      let deps = [];
      departments.forEach((dep) => {
        deps.push(this.getDepartmentRole(dep));
      });

      let rols = [];
      deps.forEach((d) => {
        if(d.role && d.role.length>0 && d.department && d.department.name){
          d.role.forEach((r) => {
            rols.push({ role: r, name: d.department.name });
          });
        }
      });

      const outputObj = rols.reduce((accum, dep) => {
        if (!accum[dep.role]) {
          accum[dep.role] = dep.name;
        } else {
          accum[dep.role] += ", " + dep.name;
        }

        return accum;
      }, {});

      const output = Object.entries(outputObj)
        .map(([key, value]) => {
          return key + " " + "(" + value + ")";
        })
        .join(", ");
      return output;
    },
    // @vuese
    //- Used to get all the  employements from the selected company and display data in table
    getEmployments() {
      this.employments = [];
      API.listCompanyEmployments(this.selectedCompany.id)
        .then((response) => {
          response.data.forEach((el) => {
            this.employments.push({
              id: el.id,
              employedId: el.employed.id,
              isAdministrator: el.isAdministrator ? this.getRoleDescription(el) : "",
              isInstructor: el.isInstructor,
              roledescription: el.roleDescription,
              fromDate: el.fromDate,
              manuallyEndedDate: el.manuallyEndedDate,
              role:
                this.selectedCompany && this.selectedCompany.hasDepartments
                  ? el.departmentEmployments
                  : this.getRoleDescription(el),
              toDate: el.toDate,
              firstName: el.employed.firstName,
              lastName: el.employed.lastName,
              email: el.employed.email,
              personalNumber: el.employed.personalNumber,
              mobilephone: el.employed.mobilephone,
              address: el.employed.address1 || "",
              zip: el.employed.zip || "",
              city: el.employed.city || "",
              tradeCertificates: el.employed.tradeCertificates,
              instructorExemptions: el.employed.instructorExemptions,
              hasTradeCert: this.hasTradeCert(el),
              hasExemtion: this.hasExemtion(el),
            });
          });
        })
        .catch((error) => {
          console.log("get employemnts", error);
        });
    },
  },
};
</script>


